const SHOP_DOMAIN_REGEX = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/;

const stripToHost = (input: string): string => {
  return input
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .split('/')[0];
};

/**
 * Normalizes user input into a canonical Shopify shop domain, mirroring the
 * backend rules: accepts a full domain, a URL pointing to it, or a bare store
 * name (my-store -> my-store.myshopify.com).
 * Returns null when the input cannot form a valid shop domain.
 */
export const normalizeShopDomain = (input: string): string | null => {
  let domain = stripToHost(input);

  if (domain !== '' && !domain.includes('.')) {
    domain = `${domain}.myshopify.com`;
  }

  return SHOP_DOMAIN_REGEX.test(domain) ? domain : null;
};

/**
 * True only when the input already spells out the full
 * {store}.myshopify.com domain (no auto-appending) — used to gate the
 * Connect button in the shop domain modal.
 */
export const isCompleteShopDomain = (input: string): boolean => {
  return SHOP_DOMAIN_REGEX.test(stripToHost(input));
};
